import {isArray, isString} from '../../../utils/util'

const showInFor = ['center', 'create', 'modify', 'current']

export const _validateSuccess = () => ({
  success: true
})

export const _validateFail = message => ({
  message,
  success: false
})

export const _createTip = (message) => ({
  message
})

export const _flexMixin = (styles) => {
  Object.entries(styles).forEach(([key, style]) => {
    if (!style.display) {
      style.display = 'flex'
    }
  })
  return styles
}

export const _setToDataProperty = (data, property) => value => {
  data[property] = value
}

export const _formatKeyMapping = keyMapping => {
  const keyMappingEntities = Object.entries(keyMapping)

  keyMappingEntities.forEach((it) => {
    let [key, mapping] = it
    if (typeof mapping === 'string') {
      mapping = it[1] = keyMapping[key] = {
        label: mapping
      }
    }
    // 格式化showIn 为特定数组
    {
      let finalShowIn = Array.from(showInFor)
      let {showIn} = mapping
      showIn = typeof showIn === 'string' ? [showIn] : showIn
      if (showIn) {
        const filtered =
          showIn.filter(it => it.indexOf('-') === 0) // 带-的，需要过滤的
        finalShowIn = filtered.length > 0
          ? finalShowIn.filter(it => !filtered.includes('-' + it)) // 取不相交的部分
          : showIn
      }
      mapping.showIn = finalShowIn
    }

    // 格式化 tip
    if (isString(mapping.tip)) {
      mapping.tip = _createTip(mapping.tip)
    }

    __convertValidate(mapping)

    if (mapping.list) {
      __convertList(mapping, key)
    }

    if (mapping.mapList) {
      __convertMapList(mapping, key)
    }
  })

  return {keyMapping, keyMappingEntities}
}

const __convertValidate = (mapping) => {
  const {validate} = mapping
  const valueIsOk = (val, data) => it => {
    if (it.required && [undefined, null, ''].includes(val)) { // 为空
      return it.message
    }
    if (it.max && val && val.length > it.max) { // 长度太长
      return it.message
    }
    if (it.min && val && val.length < it.min) { // 长度不足
      return it.message
    }
    if (it.pattern && val) { // 正则检测失败
      const patterns = isArray(it.pattern) ? it.pattern : [it.pattern]
      if (patterns.every(it => !it.test(val))) {
        return it.message
      }
    }
    if (it.validate && !it.validate(val, data)) { // 手动验证失败
      return it.message
    }
    return true
  }
  const forEachAndReturnNotTrue = (validate, f) => {
    for (let it of validate) {
      const res = f(it)
      if (res !== true) {
        return res
      }
    }
    return true
  }
  if (validate instanceof Array) {
    mapping.validate = (val, data) => {
      const v = forEachAndReturnNotTrue(validate, valueIsOk(val, data))
      return v === true ? _validateSuccess() : _validateFail(v)
    }
  }
}

const __convertMapList = (mapping, key) => {
  const {map} = mapping.mapList
  const spKey = `_${key}`

  if (!mapping.onDetailLoaded) {
    mapping.onDataLoaded = (data) => {
      data[spKey] = {
        _label: map[data[key]]
      }
    }
  }
}

const __convertList = (mapping, key) => {
  const {key: _key} = mapping.list
  if (!_key) {
    console.warn('配置有误，如存在list属性，则list对象中必须有key属性')
    console.warn(mapping, key)
    return
  }
  const {
    dataLabel,
    dataValue,
    detailLabel,
    detailValue
  } = _key
  const spKey = `_${key}`

  mapping.type = 'list'

  if (!mapping.init) {
    mapping.init = (data) => {
      data[spKey] = {}
    }
  }

  if (!mapping.onDataLoaded) {
    mapping.onDataLoaded = (data) => {
      data[spKey] = {
        loading: true,
        _label: data[dataLabel],
        _value: {
          _value: data[dataValue],
          _label: data[dataLabel]
        }
      }
    }
  }

  if (!mapping.fetchDetail) {
    mapping.fetchDetail = () => mapping.list.fetch()
      .then(list => {
        list.forEach(it => {
          it._value = it[detailValue]
          it._label = it[detailLabel]
        })
        return list
      })
  }

  if (!mapping.onDetailLoaded) {
    mapping.onDetailLoaded = (data, list) => {
      const spData = data[spKey]

      let current = mapping.list.default === undefined
        ? list.find(it => it._value === spData._value._value | 0)
        : list[mapping.list.default]

      if (current) {
        spData._value = current
        spData._label = current._label
      }
      spData.list = list
      spData.loading = false
    }
  }

  if (!mapping.beforeDataIsPost) {
    mapping.beforeDataIsPost = (data) => {
      data[dataValue] = data[spKey]._value._value
      data[dataLabel] = data[spKey]._value._label
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/di-ding/_mapping-helper.js